import Vue from 'vue';
import http from '../utils/http';

export default {
    state: {
        spots: null,
        spots_all: null,
        commercial_stories: null,
        spots_impact: [],
        //constants
        CHANNELS: [
            {   
                text_en: 'Social Media Marketing',
                text_ro: 'Marketingul pe Rețelele Sociale',
                text_ru: 'Маркетинг в Социальных Сетях',
                value:'SMM',
            }, 
            {   text_en: 'content ads',
                text_ro: 'publicitate prin conținut',
                text_ru: 'контентная реклама',
                value:'content ads'
            },
            {   text_en: 'bloggers & influencers',
                text_ro: 'bloggeri și influențatori',
                text_ru: 'блогеры и инфлюенсеры',
                value:'bloggers & influencers'
            },
            {   text_en: 'banner ads',
                text_ro: 'bannere publicitare',
                text_ru: 'баннерная реклама',
                value:'banner ads'
            }, 
            {   text_en: 'postal mailings',
                text_ro: 'trimiteri poștale',
                text_ru: 'почтовые рассылки',
                value:'postal mailings'
            },
            {   text_en: 'outdoor ads',
                text_ro: 'reclame în aer liber',
                text_ru: 'уличная реклама',
                value:'outdoor ads'
            }, 
            {   text_en: 'autoradio podcasts',
                text_ro: 'podcasturi pentru autoradio',
                text_ru: 'подкасты в автомобильном радио',
                value:'autoradio podcasts'
            },
            {   text_en: 'TV',
                text_ro: 'TV',
                text_ru: 'телевидение',
                value:'TV' 
            }   
        ],
        OBJECTIVES: [{
                text_en: 'create demand',
                text_ro: 'a genera cerere',
                text_ru: 'создать спрос',
                value:'create demand',
            }, 
            {   text_en: 'stimulate purchase',
                text_ro: 'a stimula achiziția',
                text_ru: 'стимулировать покупку',
                value:'stimulate purchase'
            }, 
            {   text_en: 'maintain loyalty',
                text_ro: 'a menține loialitatea',
                text_ru: 'сохранять лояльность',
                value:'maintain loyalty'
            }, 
            {   text_en: 'introduce feature',
                text_ro: 'prezenta o funcție',             
                text_ru: 'представить функциональное расширение',
                value:'introduce feature'
            }],
    },
    mutations: {
        loadAllSpots(state, payload) {
			state.spots_all = payload;
		},
        loadSpots(state, payload) {
			state.spots = payload;
		},
        loadCommercialStories(state, payload) {
           state.commercial_stories = payload; 
        },
        loadSpotsImpact(state, payload) {
			state.spots_impact = payload;
		},
        addSpot(state, payload) {
            if (!state.spots_all) {
                state.spots_all = [payload];
            } else {
                const index = state.spots_all.length
                Vue.set(state.spots_all, index, payload)
            }   
        },
        addTeamSpot(state, payload) {
            if (!state.spots) {
                state.spots = [payload];
            } else {
                const index = state.spots.length;
                Vue.set(state.spots, index, payload);
            }  
        },
        editTeamSpot(state, payload) {
            const current = state.spots?.find(sp => sp.id == payload.id);
            if (current) {
                const index = state.spots.indexOf(current);
                Vue.set(state.spots, index, {...current, ...payload})
            }   
        },
        addCommercialStory(state, payload) {
            if (!state.commercial_stories) {
                state.commercial_stories = [payload];
            } else {
                const index = state.commercial_stories.length
                Vue.set(state.commercial_stories, index, payload)
            }  
        },
        editCommercialStory(state, payload) {
            const story = state.commercial_stories?.find(s => s.id == payload.id)
            if (story) {
                let index = state.commercial_stories?.indexOf(story);
                Vue.set(state.commercial_stories, index, {...story, ...payload })  
            }   
        },
        deleteSpot(state, payload) {
            state.spots =  state.spots.filter(item => item.id !== payload)
        },
        deleteAllSpot(state, payload) {
            state.spots_all =  state.spots_all?.filter(item => item.id !== payload);
        },
        deleteCommercialStory(state, payload) {
            state.commercial_stories = state.commercial_stories?.filter(item => item.id !== payload)
        }
    },
    actions: {
        //fetch all spots by game id & round
        async fetchSpots({commit}, payload) {
            commit('clearError')
			commit('setLoading', true)
            
            try {
                const result = await http.get(`/spot/game/${payload.gameId}?round=${payload.round}`);
                console.log(result)
                if (result) {
                   const spots = await result.data 
                   commit('loadAllSpots', spots)
                }              
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
				commit('setLoading', false)
				throw error
            }
        },
        async fetchTeamSpots({commit}, payload) {
            commit('clearError')
			commit('setLoading', true)
            
            try {
                const result = await http.get(`/spot/team/${payload.teamId}?gameId=${payload.gameId}&round=${payload.round}`);
                //console.log(result)
                if (result.status == 200) {
                   const spots = await result.data 
                   commit('loadSpots', spots)
                }              
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
				commit('setLoading', false)
				throw error
            }
        },
        //fetch all commercial stories
        async fetchCommercialStories({commit}, payload) {
            commit('clearError')
			commit('setLoading', true)
            //payload == category
            
            try {
                const result = await http.get(`/commercial-story/${payload}`);
                //console.log(result)
                if (result) {
                   const stories = await result.data 
                   commit('loadCommercialStories', stories)
                }              
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
				commit('setLoading', false)
				throw error
            }
        },
        //fetch all spots impact
        async fetchSpotsImpact({commit}, payload) {
            commit('clearError')
			commit('setLoading', true)
           
            try {
                const result = await http.get(`/impact/game/${payload.gameId}?round=${payload.round}`);
                //console.log(result)
                if (result) {
                   const spots_impact = await result.data 
                   commit('loadSpotsImpact', spots_impact)
                }              
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
				commit('setLoading', false)
				throw error
            }
        },
        async addSpot({commit}, payload) {
            commit('clearError')
			commit('setLoading', true)

            const team = payload.team;
            delete payload.team;
            payload.teamId = team.id;

            const trademark = payload.trademark;
            delete payload.trademark;
            payload.trademarkId = trademark.id;

            const commercial_story = payload.commercial_story;
            delete payload.commercial_story;
            payload.storyId = commercial_story.id;

            try {
                const result = await http.post(`/spot`, payload);
                
                if (result) {
                   const spot = await result.data; 
                   spot.team = team;
                   spot.trademark = trademark;
                   spot.commercial_story = commercial_story;
                   commit('addSpot', spot);
                }                              
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
				commit('setLoading', false)
				throw error
            }
        },
        async addTeamSpot({commit}, payload) {
            commit('clearError')
			commit('setLoading', true)

            const team = payload.team;
            delete payload.team;
            payload.teamId = team.id;

            const trademark = payload.trademark;
            delete payload.trademark;
            payload.trademarkId = trademark.id;

            const commercial_story = payload.commercial_story;
            delete payload.commercial_story;
            payload.storyId = commercial_story.id;

            try {
                const result = await http.post(`/spot`, payload);
                
                if (result) {
                   const spot = await result.data; 
                   spot.team = team;
                   spot.trademark = trademark;
                   spot.commercial_story = commercial_story;
                   commit('addTeamSpot', spot);
                }                              
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
				commit('setLoading', false)
				throw error
            }
        },
        //add commercial story
        async addCommercialStory({commit}, payload) {
            commit('clearError')
			commit('setLoading', true)

            try {
                const result = await http.post(`/commercial-story`, payload);               
                if (result) {
                   const story = await result.data; 
                   commit('addCommercialStory', story);
                }                              
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
				commit('setLoading', false)
				throw error
            }
        },
        //edit team spot
        async editTeamSpot({commit}, payload) { 
            commit('clearError')
			commit('setLoading', true)
            try {
                await http.put(`/spot/${payload.id}`, payload);               
                
                commit('editTeamSpot', payload);                             
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
				commit('setLoading', false)
				throw error
            }
        },
        //edit commercial story
        async editCommercialStory({commit}, payload) { 
            commit('clearError')
			commit('setLoading', true)
            try {
                await http.put(`/commercial-story/${payload.id}`, payload);               
                
                commit('editCommercialStory', payload);                             
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
				commit('setLoading', false)
				throw error
            }
        },
        async deleteSpot({ commit }, payload) {
            commit('clearError')
            commit('setLoading', true)

            try {
                await http.delete(`/spot/${payload}`);
                commit('deleteSpot', payload)            
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
                commit('setLoading', false)
                throw error
            } 
        },
        async deleteAllSpot({ commit }, payload) {
            commit('clearError')
            commit('setLoading', true)

            try {
                await http.delete(`/spot/${payload}`);
                commit('deleteAllSpot', payload)            
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
                commit('setLoading', false)
                throw error
            } 
        },
        async deleteCommercialStory({ commit }, payload) {
            commit('clearError')
            commit('setLoading', true)

            try {
                await http.delete(`/commercial-story/${payload}`);
                commit('deleteCommercialStory', payload)            
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
                commit('setLoading', false)
                throw error
            } 
        },
        async spotsTransition({commit}, payload) {
            commit('clearError')
			commit('setLoading', true)
            
            try {
                await http.get(`/spot/transition/${payload.gameId}?round=${payload.round}`);            
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
				commit('setLoading', false)
				throw error
            }
        },
        /* calculate spots impact by game & round */
        async calculateSpotsImpact({ commit }, payload) {
            commit('clearError')
            commit('setLoading', true)
            //console.log(payload)
            try {
                const result = await http.get(`/impact/calculate/${payload.gameId}?round=${payload.round}`);
                //console.log(result)
                if (result) {
                   const spots_impact = result.data 
                   commit('loadSpotsImpact', spots_impact) //
                }
                               
                commit('setLoading', false)
            }
            catch(error) {
                commit('setError', error.message)
                commit('setLoading', false)
                throw error
            } 
        },
    },
    getters: {
        spots (state) {
            return state.spots; //team
        },
        spots_all (state) {
            return state.spots_all;
        },
        commercial_stories (state) {
            return state.commercial_stories;
        },
        spots_impact (state) {
            return state.spots_impact;
        },
        CHANNELS (state) {
            return state.CHANNELS;
        },
        OBJECTIVES (state) {
            return state.OBJECTIVES;
        }
    }
}